import { Images } from "../../../Images";
import Totals from "../../../model/crew/Totals";
import BigNum from "../../../model/math/BigNum";
import NumberFormatter from "../../../util/NumberFormatter";
import CurrencyContainerSectionView from "./CurrencyContainerSectionView";

export default class PrestigeSectionView extends CurrencyContainerSectionView {
  /**
   * @param {string} parentId 
   * @param {Totals} totals 
   */
  constructor(parentId, totals) {
    super(parentId, parentId + 'prestige_section', 'Prestige', Images.currency.prestige, totals);

    /**
     * @constant
     * @type {BigNum}
     */
    this.displayedPrestige = new BigNum(0);
    /**
     * @constant
     * @type {BigNum}
     */
    this.displayedUnclaimedPrestige = new BigNum(0);

    /**
     * @type {string}
     */
    this.formattedPrestigeValue = null;

  }

  /**
   * @override
   */
  updateViewContents() {

    const prestige = this.totals.prestige;
    const unclaimedPrestige = this.totals.unclaimedPrestige;

    if (!this.formattedValue || !prestige.equals(this.displayedPrestige) || !unclaimedPrestige.equals(this.displayedUnclaimedPrestige)) {
      this.displayedPrestige.copy(prestige);
      this.displayedUnclaimedPrestige.copy(unclaimedPrestige);

      if (unclaimedPrestige.equalsZero()) {
        this.formattedValue = NumberFormatter.formatBigNum(prestige);
      }
      else {
        this.formattedValue = NumberFormatter.formatBigNum(prestige) + ' (' + NumberFormatter.formatBigNum(unclaimedPrestige) + ')';
      }

      this.valueElement.innerHTML = this.formattedValue;
    }
  }

}